// Status values for the status field
export const CampaignStatus = {
  WAITING: 'waiting',
  AVAILABLE: 'available',
  BLOCKED: 'blocked',
} as const;

export type CampaignStatusType = typeof CampaignStatus[keyof typeof CampaignStatus];

// Keep old PromotionStatus for backward compatibility with promotionStatus field
export const PromotionStatus = {
  WAITING: 'waiting',
  UPCOMING: 'upcoming',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  BLOCKED: 'blocked',
} as const;

export type PromotionStatusType = typeof PromotionStatus[keyof typeof PromotionStatus];

// Updated filters to use status field values
export const CAMPAIGN_STATUS_FILTERS = [
  {
    label: "Tất cả",
    value: "all" as const,
  },
  {
    label: "Đang chờ",
    value: CampaignStatus.WAITING,
  },
  {
    label: "Sẵn sàng",
    value: CampaignStatus.AVAILABLE,
  },
  {
    label: "Đã chặn",
    value: CampaignStatus.BLOCKED,
  },
];

// Keep old filter for backward compatibility
export const PROMOTION_STATUS_FILTERS = [
  {
    label: "Tất cả",
    value: "all" as const,
  },
  {
    label: "Đang chờ",
    value: PromotionStatus.WAITING,
  },
  {
    label: "Sắp diễn ra",
    value: PromotionStatus.UPCOMING,
  },
  {
    label: "Đang hoạt động",
    value: PromotionStatus.ACTIVE,
  },
  {
    label: "Đã hết hạn",
    value: PromotionStatus.EXPIRED,
  },
  {
    label: "Đã chặn",
    value: PromotionStatus.BLOCKED,
  },
];

export type FilterValue = "all" | CampaignStatusType | PromotionStatusType;